import { type PropsWithChildren } from 'react';
import { trans } from '@lingoda/i18n';
import { GuidanceOverlay, type SxProps, type Theme } from '@lingoda/ui';
import { useMyCourseGuidanceBanner } from './hooks';

interface Props {
    popperPropsSx?: SxProps<Theme>;
}

export const MyCourseGuidanceOverlay = ({
    children,
    popperPropsSx = defaultPopperProps,
}: PropsWithChildren<Props>) => {
    const { isVisible, handleDismiss } = useMyCourseGuidanceBanner();

    if (!isVisible) {
        return <>{children}</>;
    }

    return (
        <GuidanceOverlay
            open={isVisible}
            title={trans('guidance-overlay-title', {}, 'student-common')}
            body={trans('guidance-overlay-body', {}, 'student-common')}
            onDismiss={handleDismiss}
            popperProps={{
                disablePortal: true,
                placement: 'top-start',
                modifiers: [
                    {
                        name: 'flip',
                        enabled: false,
                    },
                ],
                sx: popperPropsSx,
            }}
        >
            {children}
        </GuidanceOverlay>
    );
};

const defaultPopperProps = {
    position: 'relative !important',
    transform: 'none !important',
};
